@if (status != null) {
  <div class="signing-status-tag" [class]="SigningStatus[status]">
    <span>{{ signingStatusLabels[status] }}</span>
  </div>
}
